import React, {useState} from 'react'
import './Contact.css'
import { validateMobileNumber, validateEmail } from '../Utils/Validation';
import { db } from '../firebase/firebase'; // Firebase configuration file
import { collection, addDoc } from "firebase/firestore";
import { useAuth } from '../firebase/AuthContext';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loader/Loadering';
import { motion } from 'framer-motion';

export default function Contact() {

  const { user } = useAuth();
  const [mobileNo, setMobileNo] = useState('');
  const [isMobileValid, setIsMobileValid] = useState(false); // Add this state
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [fullname, setFullname] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false); // Loader state
  

  // const handleInputNumberChange = (event) => {
  //   const value = event.target.value;
  //   const onlyNums = value.replace(/[^0-9]/g, '');
  //   setMobileNo(onlyNums);
  // };
const navigate = useNavigate();

  // const handleContactNoChange  = (event) => {
  //       validateMobileNumber(event.target.value, setMobileNo);
  //     };
  const handleContactNoChange = (event) => {
    const isValid = validateMobileNumber(event.target.value, setMobileNo);
    setIsMobileValid(isValid); // Update validation status
  };

  const handleEmailChange = (event) => {
        validateEmail(event.target.value, setEmail, setIsEmailValid);
      };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload on form submit

    if (!user) {
      alert('You need to log in before submitting the form.');
      navigate('/login');
      return;
    }

    if (!isEmailValid) {
      alert('Please enter a valid email address.');
      return;
    }

    // Check if mobile number starts with '03' or '923'
  // if (!mobileNo.startsWith('03') && !mobileNo.startsWith('923')) {
  //   alert('Invalid phone number. Please start with "03" or "923".');
  //   return;
  // }
  if (!isMobileValid) {
    alert("Please enter a valid mobile number.");
    return;
  }
  setLoading(true); // Start loading
    try {
      // Firebase Firestore me data save karein
      // const docRef = await addDoc(collection(db, 'contactUs'), {
        await addDoc(collection(db, 'contactUs'), {
        fullname: fullname,
        mobileNo: mobileNo,
        email: email,
        message: message,
        timestamp: new Date().toISOString(),
        readTimestamp: null,
        submittedBy: user.uid, // Store the user ID
      });

      // console.log('Document written with ID: ', docRef.id);
      alert('Submitted successfully!');

      // Clear form fields after submission
      setFullname('');
      setMobileNo('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('Error adding document: ', error);
      alert('Failed to submit. Please try again.');
    }finally {
      setLoading(false); // Stop loading after submission attempt
    }
  };


  // Animation variants for Framer Motion
  const formVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const inputVariants = {
    focus: { scale: 1.05, transition: { duration: 0.2 } },
  };

  return (
    <>
    <motion.div 
    className='contact-page-container'
    initial="hidden"
    animate="visible"
    variants={formVariants}
    >
      <motion.form onSubmit={handleSubmit}>
        <motion.label> Enter Full Name
          <motion.input 
           type='text'
           name='fullname' 
           value={fullname} 
           placeholder='john' 
           onChange={(e) => setFullname(e.target.value)}
           required
           whileFocus="focus"
           variants={inputVariants}
          />
        </motion.label>
      
        <motion.label> Enter Mobile No. <span style={{color:"#f26a49"}}>OR</span> Whatsapp No.
          <motion.input
            type='text'
            name='mobileno' 
            placeholder='0309xxxxxxx or 923xxxxxxxxx'  
            value={mobileNo} 
            onChange={handleContactNoChange} 
            required
            whileFocus="focus"
            variants={inputVariants}
          />
        </motion.label>
        
        <motion.label> Enter Email Address
          <motion.input 
            type='text'  
            name='email' 
            placeholder='john123@gmail.com' 
            value={email} 
            onChange={handleEmailChange} 
            required
            whileFocus="focus"
            variants={inputVariants}
          />
          {!isEmailValid && email !== '' && (
            <div style={{ color: 'red', fontSize:'15px' }}>
              Email wrong formatting
            </div>
          )}
          {isEmailValid && email !== '' && (
          <div style={{ color: 'green', fontSize: '15px' }}>
            Excellent
          </div>
        )}
        </motion.label>

        <motion.label> Write Message
          <motion.textarea 
           name='Message' 
           placeholder='Message...' 
           value={message}
           onChange={(e) => setMessage(e.target.value)}
           required 
           className='textarea' 
           whileFocus="focus"
           variants={inputVariants}
          />
        </motion.label>
      
        <button 
        type="submit" 
        disabled={loading}
        >
          {loading && <Loading /> }
          Send
        </button>
      </motion.form>
    </motion.div>
    </>
  )
}


// import React, {useState} from 'react'
// import './Contact.css'

// export default function Contact() {

//   const [mobileNo, setMobileNo] = useState('');

//   const [email, setEmail] = useState('');
//   const [isEmailValid, setIsEmailValid] = useState(true);

//   const handleInputNumberChange = (event) => {
//     const value = event.target.value;
//     const onlyNums = value.replace(/[^0-9]/g, '');
//     setMobileNo(onlyNums);
//   };

//   const handleInputEmailChange = (event) => {
//     const value = event.target.value;
//     setEmail(value);
//     const emailPattern = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
//     setIsEmailValid(emailPattern.test(value) || value === '');
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();

//     const fullName = event.target.fullname.value;
//     const mobileNo = event.target.mobileno.value;
//     const email = event.target.email.value;
//     const message = event.target.Message.value;

//     const yourWhatsAppNumber = '923091416573';
//     const formattedMessage = `Full Name: ${fullName}\nEmail Address: ${email}\nmobile Number: ${mobileNo}\nMessage: ${message}`;
//     const whatsappUrl = `https://wa.me/${yourWhatsAppNumber}?text=${encodeURIComponent(formattedMessage)}`;

//     window.open(whatsappUrl, '_blank');
//   };

//   return (
//     <>
//     <div className='contact-page-container'>
//       <form onSubmit={handleSubmit}>
//         <label> Enter Full Name
//           <input type='text' name='fullname' placeholder='john' required/>
//         </label>
      
//         <label> Enter Mobile No. <span style={{color:"#f26a49"}}>OR</span> Whatsapp No.
//           <input type='text' name='mobileno' placeholder='0309xxxxxxx'  value={mobileNo} onChange={handleInputNumberChange} required/>
//         </label>
        
//         <label> Enter Email Address
//           <input type='text'  name='email' placeholder='john123@gmail.com' value={email} onChange={handleInputEmailChange} required/>
//           {!isEmailValid && email !== '' && (
//             <div style={{ color: 'red', fontSize:'15px' }}>
//               Email wrong formatting
//             </div>
//           )}
//           {isEmailValid && email !== '' && (
//           <div style={{ color: 'green', fontSize: '15px' }}>
//             Excellent
//           </div>
//         )}
//         </label>

//         <label> Write Message
//           <textarea name='Message' placeholder='Message...' required className='textarea' />
//         </label>
      
//         <button type="submit">Send</button>
//       </form>
//     </div>
//     </>
//   )
// }
